import {
  Box_default
} from "./chunk-GDQZHQO7.js";

// packages/ui-lib/src/layout/Columns.tsx
import React2 from "react";
import cn from "classnames";

// packages/ui-lib/src/layout/Columns.css.ts
var column = "Columns__1r3fika7";
var columns = "Columns__1r3fika1";
var space = { none: "Columns_none__1r3fika2", xs: "Columns_xs__1r3fika3", small: "Columns_small__1r3fika4", medium: "Columns_medium__1r3fika5", large: "Columns_large__1r3fika6" };
var width = { "1/2": "Columns_1/2__1r3fika8", "1/3": "Columns_1/3__1r3fika9", "2/3": "Columns_2/3__1r3fikaa", "1/4": "Columns_1/4__1r3fikab", "3/4": "Columns_3/4__1r3fikac", "1/5": "Columns_1/5__1r3fikad", "2/5": "Columns_2/5__1r3fikae", "3/5": "Columns_3/5__1r3fikaf", "4/5": "Columns_4/5__1r3fikag" };

// packages/ui-lib/src/layout/Columns.tsx
var Columns = ({
  align,
  alignY,
  space: space2,
  boxHeight,
  children
}) => /* @__PURE__ */ React2.createElement(Box_default, {
  display: "flexRow",
  justifyContent: align,
  alignItems: alignY,
  boxHeight,
  className: cn(columns, space2 && space[space2])
}, children);
var Column = ({ children, width: width2 }) => /* @__PURE__ */ React2.createElement(Box_default, {
  boxMinWidth: 0,
  boxWidth: width2 !== "content" ? "full" : void 0,
  flexShrink: width2 === "content" ? 0 : void 0,
  className: cn(column, width2 != null && width2 !== "content" && width[width2])
}, children);

export {
  Columns,
  Column
};
//# sourceMappingURL=chunk-6FTABYOX.js.map
